module.exports = __webpack_public_path__ + "img/kongtiao.f3724dff.png";